/**
 * Prod /sale checkout: RegisterForm planId={4} + auto-applied coupon.
 * `?coupon=` still overrides this (same as RegisterForm).
 */
export const SALE_PLAN_ID = 4;
export const SALE_DEFAULT_COUPON = "bull2027";

/** Prod Newsale featured Wistia id. */
export const SALE_PROMO_WISTIA_ID = "fwaxun2z59";

/** Midnight October 8, 2026, US Eastern (EDT, UTC−4). */
export const SALE_COUNTDOWN_END = "2026-10-08T00:00:00-04:00";

/** /sale stays up only until this instant. Set a future end to open the next sale. */
export const isSaleLive = (now = Date.now()) => {
  const end = Date.parse(SALE_COUNTDOWN_END);
  return Number.isFinite(end) && now < end;
};

export const SALE_BENEFITS = [
  "Real-Time Trade Alert Ideas",
  "Technical Analysis Training",
  "Frequent market posts by Analysts",
  "Intuitive Learning Platform",
  "Chats, Alerts, Webinars, and Reports",
];
